<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="BtnExtra">
                <button type="button" @click="Guardar()" class="btn btn-sm btn-success" :disabled="ButtonSavePermiso.DisabledSave"> 
                    <i :class="ButtonSavePermiso.Icono"></i> {{ButtonSavePermiso.TxtButton}}
                </button>
            </template>

			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Correo</th>
                <th :class="StyleTh">App</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Nombre}}</p></td>
                    <td>
                        <div class="form-check form-switch">
                            <input v-model="lista.Correo" @change="setDataNotificacion(lista)" class="form-check-input" type="checkbox" role="switch" :id="'flexSwitchCheckCorreo_'+index">
                            <label class="form-check-label" :for="'flexSwitchCheckCorreo_'+index"></label>
                        </div>
                    </td>
                    <td>
                        <div class="form-check form-switch">
                            <input v-model="lista.App" @change="setDataNotificacion(lista)" class="form-check-input" type="checkbox" role="switch" :id="'flexSwitchCheckApp_'+index">
                            <label class="form-check-label" :for="'flexSwitchCheckApp_'+index"></label>
                        </div>
                    </td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
			</template>
		</CList>
	</div>
</template>

<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCorreoCliente';

export default {
    name: 'ListaCorreoCliente',
    props:['pObjEnviado'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Notificaciones de ',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                BtnReturnShow: true,
                ShowTitleFirst: false,
                EmitSeccion: EmitEjecuta,
                ShowFiltros: false,
                ShowPaginador: false,
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ButtonSavePermiso: {
                TxtButton: 'Guardar',
                Icono: 'fa fa-plus-circle',
                DisabledSave: false,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            ObjCliente: {},
            ArregloAsignados: [],
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("notificacionClientes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdCliente: this.ObjCliente.IdCliente,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Regresar(){
            this.$router.push({name:'clientes',params:{}});
        },
        setDataNotificacion(item)
        {
            /* let obj = {
                IdCliente: this.ObjCliente.IdCliente,

            }
            if(Tipo == 'Correo')
            {
                if(item.Correo == false)
                {}
                else
                {}
            }

            this.ArregloAsignados.push(); */
        },
        Guardar()
        {
            const datosParaEnviar = [];

            let misFilas = this.ListaArrayRows;

            // 2. Si por alguna razón extraña la API tarda, protegemos con un if
            if (!misFilas) {
                console.error("el arreglo aún no está lista.");
                return;
            }
            // console.log(this.ListaArrayRows);

           misFilas.forEach(noti => {

                // Si correo es true, agregamos una fila
                if (noti.Correo) {
                    datosParaEnviar.push({
                        IdEstatusProceso: noti.IdEstatusProceso,
                        Estatus: noti.Nombre,
                        Tipo: 'Correo'
                    });
                }

                // Si app es true, agregamos otra fila independiente
                if (noti.App) {
                    datosParaEnviar.push({
                        IdEstatusProceso: noti.IdEstatusProceso,
                        Estatus: noti.Nombre,
                        Tipo: 'App'
                    });
                }
            });

            console.log(datosParaEnviar)
            
            let formData = new FormData();
			formData.set('IdCliente', this.ObjCliente.IdCliente);
			formData.set('Notificaciones', JSON.stringify(datosParaEnviar));
            
            this.DeshabilitarBotonGuardar(true);
            this.$http.post('notificacionClientes', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then( (res) =>{
                this.DeshabilitarBotonGuardar(false);
                this.$toast.success('Información guardada');
            }).catch((err) => {
                this.DeshabilitarBotonGuardar(false);
                this.$toast.error(err.response.data.message);
			});
        },
        DeshabilitarBotonGuardar(bnd)
        {
            this.ButtonSavePermiso.DisabledSave = false;
            this.ButtonSavePermiso.TxtButton    = 'Guardar';
            this.ButtonSavePermiso.Icono        = 'fa fa-plus-circle';

            if(bnd) {
                this.ButtonSavePermiso.DisabledSave = true;
                this.ButtonSavePermiso.TxtButton    = ' Espere...';
                this.ButtonSavePermiso.Icono        = 'fa fa-spinner fa-pulse';
            }
        }
    },
    created()
    {
        if(this.pObjEnviado != undefined){
            sessionStorage.setItem('objCliente',JSON.stringify(this.pObjEnviado));
        }

        this.ObjCliente = JSON.parse(sessionStorage.getItem('objCliente'));
        this.ConfigList.Title = this.ConfigList.Title+' '+this.ObjCliente.Nombre;

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
